<template>
  <div>
    <Modal
      bgClass="overlay"
      v-model="qwerty"
      wrapper-class="modal-wrapper"
      :live="true"
      @opening="onOpen"
      :modalStyle="{height: `${modalHeight}px`}"
    >
      <template v-slot:titlebar>
        <div class="titlebar">
          <h3 v-if="location && technologyName" class="vm-title text">
            <span class='data' style="text-transform: uppercase">{{ technologyName }}</span>
            Coverage at
            <span class='data'>{{ location.address }}</span>
            is
          </h3>
          <div class="close-icon" aria-hidden="true" @click="changeLocationCoverageModalState(false)"></div>
        </div>
      </template>
      <template v-slot:content>
        <div class="grid header">
          <div>Service Provider:</div>
          <div>Coverage:</div>
        </div>
        <div class="imagined">
          <div ref="imaginedRef">
            <div class="grid" v-for="(item) in locationCoverageList" :key="item.operator.id">
              <div class="operator-label">{{ item.operator.label }}</div>
              <div class="legend-level">
                <div class="legend-level__color" :style="{background: item.level.color}"></div>
                <span class="legend-level__label">{{ item.level.label }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="items">
          <div class="grid" v-for="(item) in locationCoverageList" :key="item.operator.id">
            <div class="operator-label">{{ item.operator.label }}</div>
            <div class="legend-level">
              <div class="legend-level__color" :style="{background: item.level.color}"></div>
              <span class="legend-level__label">{{ item.level.label }}</span>
            </div>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'LocationCoverageModal',
  props: ['showModal'],
  data() {
    return {
      headerHeight: 90,
      modalHeight: 0
    }
  },
  computed: {
    ...mapGetters('map', ['location', 'technology', 'technologyName',
      'locationCoverageList', 'locationCoverageModalState']),
    qwerty: {
      get() { return this.locationCoverageModalState },
      set(value) {
        this.changeLocationCoverageModalState(value)
      }
    }
  },
  methods: {
    ...mapActions('map', ['changeLocationCoverageModalState']),
    onOpen() {
      this.modalHeight = this.measureBlockBHeight()
    },
    measureBlockBHeight() {
      const imaginedBlock = this.$refs.imaginedRef;
      if (imaginedBlock) {
        const blockBHeight = imaginedBlock.clientHeight;
        return blockBHeight + this.headerHeight
      }
    }
  }
}
</script>

<style lang="stylus">
.modal-wrapper
  display flex
  align-items: center

.modal-wrapper .vm
  width 388px
  max-width 388px
  border-radius 4px
  max-height 80%
  padding-bottom 16px
  margin auto
  top 0

@media only screen and (max-width: 600px)
  .modal-wrapper .vm
    width 80%

@media only screen and (max-device-width: 600px)
  .modal-wrapper .vm
    width 80%

</style>

<style scoped lang="stylus">
@import "nib"

*
  font-family "Open Sans", Arial, sans-serif

.titlebar
  padding 16px
  border-bottom unset
  display grid
  grid-template-columns auto max-content
  grid-column-gap 8px

.vm-title.text
  font-size 14px

  & .data
    color #018478
    font-weight 700

.close-icon
  square(24px)
  background-size 24px 24px
  background url('/static/img/icons/close-outline-circle.svg') no-repeat
  cursor pointer

.imagined
  position absolute
  visibility hidden
  height 50px
  overflow auto

.items
  height calc(100% - 90px)
  overflow auto

.grid
  display grid
  grid-template-columns 1fr 1fr
  grid-column-gap 30px
  padding 12px 24px

  &.header
    font-size 12px
    background-color #F4F3F1
    padding 6px 24px
    color #707070

  &:not(.header)
    border-bottom 1px solid #ECEFF1

.operator-label
  word-break break-all

.legend-level
  display flex
  flex-direction row
  justify-content start
  gap 8px
  align-items center

  &__color
    width 40px
    height 24px
    border 0.5px solid #666
    background-color #CD9463
    box-sizing border-box

  &__label
    font-size 12px

</style>
